import { Component } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { DropdownOption, EntityRequest, Program, Session } from 'globals/store/programs.data';
import { programOptionsReselector, programPermissionsReselector, programSessionsActivitesMegaTagReselector, programsArray } from '../../store/reselectors/programs.reselector';
import { Dictionary } from '@ngrx/entity';
import { JoiEvent, Label } from 'globals/store/events.data';
import { loadLocal, saveLocal } from '../../helpers/helpers';
import { JoiFile } from 'globals/store/files.model';
import { stagingRequestsBySessionIdReselector } from '../../store/reselectors/performers.reselector';
import { LabelMakerData, LabelMakerDialogComponent, LabelUpdateFunctionParams } from '../../components/label-marker/label-maker.dialog.component';
import { LabelType } from '../../services/ui.service';
import { TagPanelData, getAllTagPanelData } from 'globals/store/tags.data';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { ProgramBasicsComponent } from './program-basics.component';
import { AssetsComponent } from '../assets/assets.component';
import { ProgramSetupComponent } from '../manage/manage-program-setup.component';
import { CommonModule } from '@angular/common';
import { ProgramTagPanelComponent } from './program-tag-panel.component';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { LabelsRowComponent } from 'src/app/components/label-marker/labels-row';
import { SessionStatusComponent } from 'src/app/components/events/session-status.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { EditableNotesComponent } from '../program/editable-notes.component';
import { StagingRequestsComponent } from '../manage/staging-requests.component';
import { LogisticsSessionInlayComponent } from '../manage/logisitcs-inlay.component';
import { SessionTagPanelComponent } from './session-tag-panel.component';
import { SponsorsComponent } from '../sponsors/sponsors.component';
import { PerformersComponent } from 'src/app/components/performers/performers.component';
import { ExhibitorStandsComponent } from '../exhibitors/exhibitor-stands.component';
import { exhibitorDisplayTypes } from 'globals/store/exhibitors.data';
import { IconHolderComponent } from './icon-holder.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { PermissionAccess } from 'globals/store/permissions.data';
import { MemoizedSelector } from '@ngrx/store';
import { jsonCopyObject } from 'globals/helpers/helpers';


@Component({
    selector: 'logistics-build',
    templateUrl: './logistics-build.html',
    styleUrls: ['../../page.scss', './logistics-build.scss'],
    standalone: true,
    imports: [TopMenuComponent, IconHolderComponent, LogisticsSessionInlayComponent, SessionTagPanelComponent, SponsorsComponent, PerformersComponent, ExhibitorStandsComponent, LabelsRowComponent, SessionStatusComponent, TitleIconComponent, InputEditorComponent, FileHandlerComponent, EditableNotesComponent, StagingRequestsComponent, MobileMenuComponent, LoaderPaneFragmentComponent, DropdownComponent, FindByIdPipe, IconComponent, ExpandingWrapperComponent, ToggleTabComponent, ProgramBasicsComponent, AssetsComponent, ProgramSetupComponent, CommonModule, ProgramTagPanelComponent, ProgramDayDate, IdsToItemsPipe],
})
export class LogisticsBuildComponent extends Wrapper<LogisticsBuildComponent> {
  _file = 'LogisticsBuildComponent'
  exhibitorDisplayTypes = exhibitorDisplayTypes
  programs: Program[]
  event: JoiEvent
  readOnly: boolean
  is_program: boolean
  is_logistics: boolean
  sessionLabelList: Label[]
  sessionLabelMap: Dictionary<Label>
  programOptions: DropdownOption[]
  selectedProgramId: string
  stagingRequestsBySessionId: Dictionary<EntityRequest[]> = {}
  expanded: Dictionary<boolean> = {}
  selectedLabelEntity: any
  selectedLabelType: LabelType
  tagPanelDatas: Dictionary<TagPanelData> = {}
  traceNames = traceNames
  
  constructor() {
    super()
    this.selectCallback(programsArray, null, (programs: Program[]) => {
      this.programs = programs
      this.selectedProgramId = loadLocal(`logisticsBuildProgram${this.eventService.eventId}`, null)
      if (!this.selectedProgramId || !programs.find(p => p.id === this.selectedProgramId)) this.selectedProgramId = programs[0]?.id
    })
    this.selectProp(stagingRequestsBySessionIdReselector, null, 'stagingRequestsBySessionId')
    this.selectProp(programOptionsReselector, false, 'programOptions')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.selectCallback<{ is_readonly: boolean, is_program: boolean, is_logistics: boolean }, null>(programPermissionsReselector, null, ({ is_readonly, is_program, is_logistics }) => {
      this.readOnly = is_readonly
      this.is_program = is_program
      this.is_logistics = is_logistics
    })
    this.subCallback(this.store.select('events', 'labelMaps', 'session_labels'), labels => {
      this.sessionLabelList = Object.values(labels)
      this.sessionLabelMap = labels
    })
    this.selectProp(programSessionsActivitesMegaTagReselector, true, 'tagPanelDatas')
  }

  setProgramId(programId: string) {
    this.selectedProgramId = programId
    saveLocal(`logisticsBuildProgram${this.eventService.eventId}`, programId)
  }

  addSessionAssetIds(ids: string[], session: Session) {
    session.assetIds = [...(session.assetIds || []), ...ids]
    this.programService.updateSession(this.selectedProgramId, session)
  }

  removeSessionAssetId(idToRemove: string, session: Session) {
    session.assetIds = session.assetIds.filter(id => id !== idToRemove)
    this.programService.updateSession(this.selectedProgramId,session)
  }

  async addSetup() {
    const id = await this.programService.addSetup(this.programs.find(p => p.id === this.selectedProgramId))
    this.expanded[id] = true
  }

  labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsToggled) {
      switch (this.selectedLabelType) {
        case 'session':
          const session = this.selectedLabelEntity as Session
          session.labels = labels
          this.programService.updateSession(this.selectedProgramId, session)
          break
        default:
          console.log("No handling for toggling labels for ", { labelType: this.selectedLabelType, labelEntity: this.selectedLabelEntity })
          break
      }
    }
    if (labelsChanged) {
      let update: Partial<JoiEvent>
      switch (this.selectedLabelType) {
        case 'session':
          update = { session_labels: labelTemplate }
          break
        default:
          console.log("No handling for updating labels template for ", { labelType: this.selectedLabelType, labelEntity: this.selectedLabelEntity })
          break
      }
      if (!update) return
      this.eventService.updateEvent(this.event.eventId, update)

    }
  }

  editLabels<L extends { labels?: string[] }>(evt: any, entity: L, labelList: Label[], type: LabelType = 'session') {
    if (this.readOnly) return
    evt.stopPropagation()
    const parent = evt.target.parentElement
    // console.log('parent ', parent.classList.contains('labels'));
    const labelsRect = parent.getBoundingClientRect();
    this.selectedLabelEntity = entity
    this.selectedLabelType = type
    const data: LabelMakerData = {
      labels: entity.labels || [],
      type,
      position: { top: labelsRect.top + 5, left: labelsRect.left }, // 154 is a hack to get this to line up with the three dots on the right
      labelUpdateFunction: this.labelUpdateFunction.bind(this),
      labelTemplate: labelList,
    }
    this.dialog.open(LabelMakerDialogComponent, {
      minWidth: '300px',
      backdropClass: 'backdrop',
      panelClass: 'label-panel',
      maxHeight: '99vh',
      data
    });
  }

  expandAll() {
    this.programs.forEach(p => {
      this.expanded[p.id] = true
      this.expanded[`${p.id}assets`] = true
      this.expanded[`${p.id}venue`] = true
      this.expanded[`${p.id}stands`] = true
      this.expanded[`${p.id}tags`] = true
      p.setupIds.forEach(sId => this.expanded[sId] = true)
      Object.keys(p.sessions_obj).forEach(sId => {
        this.expanded[sId] = true
        this.expanded[`${sId}assets`] = true
        this.expanded[`${sId}info`] = true
        this.expanded[`${sId}requests`] = true
        this.expanded[`${sId}notes`] = true
        this.expanded[`${sId}catering`] = true
        this.expanded[`${sId}tags`] = true
        this.expanded[`${sId}briefNotes`] = true
      })
    })
  }

  collapseAll() {
    this.expanded = {}
  }

  async saveSession(session: Session) {
    console.log("Saving session... ", jsonCopyObject(session))
    this.programService.updateSession(this.selectedProgramId, session)
  }

  async saveProgram(program: Program) {
    await this.programService.upsertProgram(program, {file:this._file, function:'saveProgram', data:{ program }}, false)
  }

  toggleSessionConfirmed(session: Session){
    session.contentStatus = session.contentStatus === "Confirmed" ? "Not Confirmed" : "Confirmed";
    this.saveSession(session)
  }

  toggleProgramConfirmed(program: Program){
    program.programConfirmed = !program.programConfirmed
    this.saveProgram(program)
  }

  
  toggleVenueConfirmed(program: Program){
    program.venueConfirmed = !program.venueConfirmed
    this.saveProgram(program)
  }

  saveAssetIds(ids: string[], program: Program) {
    const oldIds = program.assetIds || []
    program.assetIds = [...oldIds, ...ids]
    this.saveProgram(program)
  }

  addPublicLinks(files: JoiFile[], session: Session) {
    console.log({ event })
    session.publicLinks = files
    this.saveSession(session)
  }

  removeAssetId(idToRemove: string, program: Program) {
    program.assetIds = program.assetIds.filter(id => id !== idToRemove)
    this.saveProgram(program)
  }

}

